<script>
  import { useRouter } from '@dvcol/svelte-simple-router';
  import api from '$lib/api.js';
  import { authStore } from '../stores/authStore.svelte.js';
  import PageHeader from '../components/PageHeader.svelte';
  import DataTable from '../components/DataTable.svelte';
  import Pagination from '../components/Pagination.svelte';
  import EmptyState from '../components/EmptyState.svelte';

  const router = useRouter();

  let loading = $state(true);
  let error = $state(null);
  let items = $state([]);
  let pagination = $state(null);
  let page = $state(1);

  async function load() {
    loading = true;
    error = null;
    try {
      const result = await api.listProperties({
        page, limit: 25, tenant_id: authStore.tenantId ?? undefined,
      });
      items = result.items;
      pagination = result.pagination;
    } catch (e) {
      error = e.message;
    } finally {
      loading = false;
    }
  }

  $effect(() => { page; load(); });

  const columns = [
    { key: 'name', label: 'Property' },
    { key: 'address', label: 'Address', render: (r) => r.address ?? r.city ?? '—' },
    { key: 'bedrooms', label: 'Beds', align: 'right', render: (r) => r.bedrooms ?? '—' },
    { key: 'accommodates', label: 'Sleeps', align: 'right', render: (r) => r.accommodates ?? '—' },
    {
      key: 'knowledge_item_count', label: 'Knowledge', align: 'right',
      render: (r) =>
        r.knowledge_unvectorized_count
          ? `${r.knowledge_item_count} (${r.knowledge_unvectorized_count} pending)`
          : String(r.knowledge_item_count),
    },
  ];
</script>

<PageHeader title="Properties" subtitle="Properties you have access to." />

{#if error}
  <p class="p-card p-4 text-sm" style="color: var(--p-danger)">{error}</p>
{:else if !loading && !items.length}
  <EmptyState icon="fa-house" title="No properties yet"
              message="When a property manager grants you access to a property, it appears here." />
{:else}
  <DataTable {columns} rows={items} {loading}
             onRowClick={(row) => router.push({ name: 'property-detail', params: { id: row.id } })} />
  <Pagination {pagination} onPage={(p) => (page = p)} />
{/if}
